import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RefundModel } from 'src/app/models/refund.model';
import { ReturnDbService } from 'src/app/services/data/return-db.service';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';

@Component({
  selector: 'app-refund-button-commit',
  templateUrl: './refund-button-commit.component.html',
  styleUrls: ['./refund-button-commit.component.scss'],
})
export class RefundButtonCommitComponent implements OnInit {
  @Input() mode!: 'commit' | 'rollback' | 'delete' | 'reset' | 'repeat';
  @Input() refund?: RefundModel;
  @Output() refundChange = new EventEmitter<RefundModel>();
  private refundDb: ReturnDbService;
  loading = false;
  color = '';
  text?: string;
  targetStatus = 0;

  constructor(
    cm: ConnectionManagerService,
    private readonly snack: MatSnackBar
  ) {
    this.refundDb = new ReturnDbService(cm.getCurrentDb());
  }
  ngOnInit(): void {
    switch (this.mode) {
      case 'commit':
        this.text = 'подтвердить';
        this.color = 'warn';
        this.targetStatus = 2;
        break;
      case 'reset':
        this.text = 'повторить';
        this.color = 'warn';
        this.targetStatus = 2;
        break;
      // case 'rollback':
      //   this.text = 'сбросить ошибку';
      //   this.color = 'primary';
      //   this.targetStatus = 1;
      //   break;
      case 'delete':
        this.text = 'отменить';
        this.color = 'warn';
        this.targetStatus = 11;
        break;
    }
  }

  isActive(): boolean {
    if (!this.refund) return false;
    switch (this.mode) {
      case 'reset':
        return !this.loading && this.refund.statusId == 4;
      case 'commit':
        return !this.loading && this.refund.statusId == 1;
      case 'delete':
        return (
          !this.loading &&
          (this.refund.statusId == 1 || this.refund.statusId == 2)
        );
    }
    return false;
  }

  setStatus() {
    if (!this.refund) return;

    if (this.mode === 'commit') {

      let total = 0;
      this.refund.items.forEach(l => total += l.amount);

      if (total <= 0) {
        this.snack.open("Нет ни одной строки в документе", 'Закрыть', { duration: 3000 })

        return;
      }
    }

    this.loading = true;
    this.refundDb
      .commitRefund(this.refund, this.targetStatus)
      .then(r => {
        this.refund = r;
        this.refundChange.emit(r);
      })
      .catch((err) => {
        this.snack.open(
          `Ошибка обновления статуса - ${err?.message}`,
          'Закрыть',
          { duration: 5000 }
        );
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
